import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0505f4a6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0505f4a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0505f4a6')) {
      api.createRecord('0505f4a6', component.options)
    } else {
      api.reload('0505f4a6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0505f4a6&scoped=true", function () {
      api.rerender('0505f4a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cpscc/previewHtml/index.vue"
export default component.exports